import React from 'react';
import { Button as ButtonChakra } from '@chakra-ui/button';

type ButtonSize = 'xs' | 'sm' | 'md' | 'lg'

type ButtonProps = {
  label: string;
  onClick: () => void;
  variant?: 'solid' | 'outline' | 'ghost' | 'link';
  colorScheme: string;
  size?: ButtonSize | ButtonSize[];
  icon?: React.ReactElement;
  rightIcon?: React.ReactElement;
  minWidth?: number | string;
};

const Button = ({ label, onClick, size= 'md', variant = 'solid', colorScheme, icon, minWidth, rightIcon }: ButtonProps) => {
  return (
    <ButtonChakra
      onClick={onClick}
      leftIcon={icon}
      rightIcon={rightIcon}
      variant={variant}
      colorScheme={colorScheme}
      size={size}
      minW={minWidth}
      fontWeight={700}
      borderRadius={100}
    >
      {label}
    </ButtonChakra>
  );
};

export { Button };
